<template>
  <div>
    <div
      v-if="forgetShow"
      class="forgetImg"
      :style="{ backgroundImage: `url('${forgetImg}')` }"
      @touchmove.prevent
    >
      <img class="close" :src="closeImg" alt="" @click="forgetShow = false" />
      <p class="jumpGame service_text color_link" @click="onGoService">未解决问题？点击咨询客服</p>
    </div>
    <div class="wrapper" v-if="accountShow">
      <div class="content">
        <div class="top">游戏账号绑定</div>
        <div class="mid">
          <Field
            v-show="validType === 0"
            v-model="acc"
            label="游戏账号"
            :error="errorFields.includes('acc')"
            placeholder="请输入游戏账号"
          />
          <Field
            v-show="validType === 0"
            v-model="pass"
            label="游戏密码"
            :type="passType === 0 ? 'password' : 'text'"
            :right-icon="passType === 0 ? 'closed-eye' : 'eye-o'"
            placeholder="请输入游戏密码"
            :error="errorFields.includes('pass')"
            @click-right-icon="changePasswordType"
          />
          <Field
            v-show="validType === 1"
            v-model="phone"
            label="已绑定手机号"
            maxlength="11"
            placeholder="请输入手机号"
            :error="errorFields.includes('phone')"
          />
          <Field
            v-show="validType === 1"
            v-model="code"
            label="短信验证码"
            maxlength="6"
            placeholder="请输入验证码"
            :error="errorFields.includes('code')"
            @click-right-icon="changePasswordType"
          >
            <template #button>
              <van-button
                color="#ff8401"
                size="mini"
                type="primary"
                :disabled="codeTimer !== 0"
                @click="onSendValidCode"
              >
                {{ codeTimer === 0 ? '获取' : `&nbsp;&nbsp;${codeTimer}s&nbsp;&nbsp;` }}
              </van-button>
            </template>
          </Field>
        </div>
        <div class="extra_fn flex_between">
          <p class="switch_type mr_6" @click="changeValidType">
            切换至{{ validType === 0 ? '手机短信' : '账号密码' }}验证
          </p>
          <p v-show="validType === 0" @click="onShowForget">忘记账号密码</p>
        </div>
        <div class="submit" @click="onSubmit">绑定游戏账号</div>
        <p class="jumpGame" @click="jumpGame">没有游戏账号？点击前往下载游戏</p>
      </div>
      <img class="close" :src="closeImg" alt="" @click="onClose" />
    </div>
    <AccountSelectDialog
      ref="accountSelectDialog"
      @select="handleAccountSelect"
    />
    <RoleSelectDialog
      ref="roleSelectDialog"
      @change-account="handleRoleChangeAccount"
      @close="handleRoleClose"
      @confirm="handleRoleConfirm"
    />
  </div>
</template>

<script>
import { CDN_URL } from '@/config/index.js';
import {
  bindUserGameAccount as gameAccountBind,
  getBoxUserBindInfo,
  bindBoxUserToBlackCatUser,
} from '@/api/app'
import { Field, Toast, Button } from 'vant';
import {
  on_send_valid_code, on_code_verify_bind_account, on_code_verify_bind_account_lucky,
  on_password_verify_bind_account_voucher, on_code_verify_bind_account_voucher,
  on_password_verify_bind_account_retour, on_code_verify_bind_account_retour,
  on_box_verify_bind_account_voucher, on_box_verify_bind_account_retour,
  on_code_verify_bind_account_list,
} from '@/api/common';
import { signUpLotUserBind } from '@/api/activity'
import { mapState, mapActions, mapMutations } from "vuex";
import { reportData } from '@/api/report'
import AccountSelectDialog from './AccountSelectDialog.vue';
import RoleSelectDialog from './RoleSelectDialog.vue';

const COUNT_DOWN = 60

export default {
  props: {
    // 活动id，转盘活动绑定账号需要
    actId: {
      type: [Number, String],
      default: '',
    },
    actName: {
      type: String,
      default: '',
    },
    isCommon: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    Field,
    [Button.name]: Button,
    AccountSelectDialog,
    RoleSelectDialog,
  },
  data () {
    return {
      acc: '', // 账号
      pass: '', // 密码
      phone: '', // 手机号
      code: '', // 验证码
      passType: 0, // 0.不可看密码 1.可看
      closeImg: `${CDN_URL}/imperialGlory/dialog-mid-close.png`,
      forgetImg: `${CDN_URL}/996/step.png`,
      forgetShow: false, // 忘记账号密码
      accountShow: false, // 账号绑定
      validType: 0, // 验证方式 0.账号 1.手机短信
      errorValid: false,
      codeTimer: 0, // 验证码倒计时
      submitLoading: false, // 提交按钮loading
      boxBindInfo: null, // 盒子用户已绑定的账号信息
      boxBindInfoLoading: false,
      boxBindSubmitLoading: false,
      boxBindQueryKey: 0,
      reportActId: '',
      reportActName: '',
    }
  },
  computed: {
    // 非公共账号绑定信息，但是需要判断盒子关联账号的
    isCheckBoxBindAccount() {
      const routeName = this.$route.name 
      return ['voucherAct', 'activity.retourGame'].includes(routeName)
    },
    ...mapState('account', {
      globalUserInfo: (state) => state.userInfo,
    }),
    hasBoundGameAccount() {
      const { game_account, game_user_id } = this.globalUserInfo || {};
      return !!(game_account || (game_user_id && Number(game_user_id) !== 0));
    },
    // 需要提示的字段
    errorFields () {
      if (!this.errorValid) return []
      const e_list = []
      if (this.validType === 0) {
        if (!this.acc) e_list.push('acc')
        if (!this.pass) e_list.push('pass')
      } else {
        if (!this.phone) e_list.push('phone')
        if (!this.code) e_list.push('code')
      }
      return e_list
    },
  },
  methods: {
    ...mapActions('account', {
      getUserInfo: 'getUserInfo'
    }),
    getBindAssets () {
      const routeName = this.$route.name
      const assetsMap = {
        drawLot: {
          tokenLabel: 'rlaToken',
          api1: signUpLotUserBind,
          api2: on_code_verify_bind_account_lucky
        },
        voucherAct: {
          tokenLabel: 'vToken',
          api1: on_password_verify_bind_account_voucher,
          api2: on_code_verify_bind_account_voucher,
          api3: on_box_verify_bind_account_voucher
        },
        ['activity.retourGame']: {
          tokenLabel: 'laToken',
          api1: on_password_verify_bind_account_retour,
          api2: on_code_verify_bind_account_retour,
          api3: on_box_verify_bind_account_retour
        },
      }
      return assetsMap[routeName] || {}
    },
    onSubmit () {
      if (!this.onValid()) return
      if (this.submitLoading) return
      this.submitLoading = true
      this.EVENT_TRACK(2, { btn_type: 1 })
      const routeName = this.$route.name
      const assets = this.getBindAssets()
      if (this.validType === 0) {
        const api = this.isCommon ? gameAccountBind : assets.api1
        api({
          account: this.acc,
          password: this.pass,
          id: this.actId,
        }).then(res => {
          const res_account = this.isCommon ? this.acc : res.data[assets.tokenLabel + this.actId]
          this.$emit('update', res_account, 0)
          this.onSuccess(res_account)
        }).finally(() => this.submitLoading = false)
      } else {
        const api = this.isCommon ? on_code_verify_bind_account : assets.api2
        // 2025.12.20 改造，礼包中心、签到活动，手机号绑定需要走多账号判断
        if (['giftCenter.home', 'giftCenter.details', 'giftCenter.activatedGame', 'giftCenter.allGift', 'signAct'].includes(routeName)) {
          on_code_verify_bind_account_list({
            phone: this.phone,
            code: this.code,
            id: this.actId,
          }).then((res) => {
              if (res.data && res.data.length > 0) {
                this.$refs.accountSelectDialog.open(res.data);
              } else {
                Toast.fail('未查询到相关账号');
              }
            })
            .finally(() => (this.submitLoading = false));
        } else {
          api({
            phone: this.phone,
            code: this.code,
            id: this.actId,
          })
            .then((res) => {
              const res_account = this.isCommon
                ? res.data.game_account
                : res.data[assets.tokenLabel + this.actId];
              this.$emit('update', res_account, 1);
              this.onSuccess();
            })
            .finally(() => (this.submitLoading = false));
        }
      }
    },
    handleAccountSelect(res) {
      // 选中账号后，更新账号信息
      const selectedAccount = (res && res.data && res.data.game_account) || '';
      this.$emit('update', selectedAccount, 1);
      this.onSuccess(selectedAccount);
    },
    handleRoleChangeAccount() {
      this.EVENT_TRACK(3);
      this.boxBindInfo = null;
      this.accountShow = true;
    },
    handleRoleClose() {
      this.boxBindInfo = null;
      this.onClose();
    },
    handleRoleConfirm() {
      this.EVENT_TRACK(4);
      if (!this.boxBindInfo) {
        Toast.success('账号已确认');
        return;
      }
      if (this.boxBindSubmitLoading) return;
      this.boxBindSubmitLoading = true;
      const { game_account, game_user_id } = this.boxBindInfo;
      const assets = this.getBindAssets();
      const api = assets.api3 || bindBoxUserToBlackCatUser;
      const params = {
        game_account,
        game_user_id,
      };
      if (assets.api3) params.id = this.actId;
      api(params).then((res) => {
        const res_account = assets.api3
          ? res.data[assets.tokenLabel + this.actId]
          : game_account;
        this.$emit('update', res_account, 0);
        this.onSuccess(res_account, { showRoleDialog: false });
      }).finally(() => {
        this.boxBindSubmitLoading = false;
      });
    },
    onSuccess (account = '', options = {}) {
      const { showRoleDialog = false } = options;
      Toast.success('账号绑定成功');
      this.errorValid = false
      this.codeTimer = 0
      this.clearCodeTimer()
      this.onClose()
      this.getUserInfo()
      if (showRoleDialog) {
        this.$nextTick(() => {
          this.$refs.roleSelectDialog && this.$refs.roleSelectDialog.open(account);
        });
      }

      this.acc = ''
      this.pass = ''
      this.phone = ''
      this.code = ''
    },
    // 验证字段
    onValid () {
      this.errorValid = true
      if (this.validType === 0) {
        if (!this.acc || !this.pass) {
          return false
        }
      } else {
        if (!this.phone || !this.code) {
          return false
        }
        if (!this.onValidPhone()) return false
      }
      return true
    },
    onValidPhone () {
      // 宽泛的手机号验证
      if (!/^1[3456789]\d{9}$/.test(this.phone)) {
        Toast.fail('请输入正确的手机号');
        return false
      }
      return true
    },
    // 发送验证码
    onSendValidCode () {
      if (!this.onValidPhone()) return false;
      on_send_valid_code({
        phone: this.phone,
      }).then(res => {
        Toast.success('验证码发送成功');
        this.triggerCountdown()
      })
    },
    // 处理倒计时
    triggerCountdown () {
      this.codeTimer = COUNT_DOWN
      this.codeTimerInterval = setInterval(() => {
        this.codeTimer--
        if (this.codeTimer === 0) {
          this.clearCodeTimer()
        }
      }, 1000)
    },
    clearCodeTimer () {
      if (this.codeTimerInterval) {
        clearInterval(this.codeTimerInterval)
        this.codeTimerInterval = null
      }
      this.codeTimer = 0
    },
    triggerVisible (flag, options = {}) {
      if (flag) {
        this.reportActId = options.actId || options.act_id || this.actId || '';
        this.reportActName = options.actName || options.act_name || this.actName || '';
      }
      
      if (!flag) {
        this.boxBindQueryKey += 1;
        this.accountShow = false;
        this.boxBindInfo = null;
        return;
      }
      this.EVENT_TRACK(1)
      if (options.isSwitchAccount || (this.isCommon && this.hasBoundGameAccount)) {
        this.boxBindQueryKey += 1;
        this.boxBindInfo = null;
        this.boxBindInfoLoading = false;
        this.accountShow = true;
        return;
      }

      // 如果是统一的登录绑定，或者是 特殊活动的绑定，需要校验下是否有盒子关联账号
      if (this.isCommon || this.isCheckBoxBindAccount) {
        this.checkBoxUserBindInfo(++this.boxBindQueryKey)
        return;
      }

      this.boxBindQueryKey += 1;
      this.boxBindInfo = null;
      this.boxBindInfoLoading = false;
      this.accountShow = true;
    },
    checkBoxUserBindInfo(queryKey) {
      this.boxBindInfoLoading = true;
      getBoxUserBindInfo()
        .then((res) => {
          if (queryKey !== this.boxBindQueryKey) return;
          const info = res && res.data ? res.data : {};
          if (info.game_account && info.game_user_id) {
            this.boxBindInfo = info;
            this.accountShow = false;
            this.EVENT_TRACK(5);
            this.$nextTick(() => {
              this.$refs.roleSelectDialog && this.$refs.roleSelectDialog.open(info.game_account);
            });
          } else {
            this.accountShow = true;
          }
        })
        .catch(() => {
          if (queryKey !== this.boxBindQueryKey) return;
          this.accountShow = true;
        })
        .finally(() => {
          if (queryKey === this.boxBindQueryKey) {
            this.boxBindInfoLoading = false;
          }
        });
    },
    changeValidType () {
      this.EVENT_TRACK(2, { btn_type: this.validType === 0 ? 2 : 3 })
      this.validType = this.validType === 1 ? 0 : 1;
      this.errorValid = false;
    },
    changePasswordType () {
      this.passType = this.passType === 1 ? 0 : 1;
    },
    onShowForget () {
      this.forgetShow = true
      this.EVENT_TRACK(2, { btn_type: 4 })
    },
    // 点击跳转
    jumpGame() {
      this.onClose()
      this.$router.push({ name: 'gameCenter.home', query: this.$route.query });
    },
    // 联系客服
    onGoService () {
      this.forgetShow = false
      this.$router.push({
        name: 'service',
      })
      // window.open('https://tb.53kf.com/code/app/10236926/8', '_self');
    },
    onClose () {
      this.$emit('close')
      this.triggerVisible(false)
    },
    EVENT_TRACK (data_type, params = {}) {
      const { name } = this.$route
      const PAGE_TYPE_MAP = {
        'personalCenter.home': 1, // 个人主页
        'giftCenter.home': 2,
        'drawLot': 3,
        'limitedAct': 4,
        'signAct': 5,
        'activity.retourGame': 6,
      }
      const actParams = {}
      const actId = this.reportActId || this.actId
      const actName = this.reportActName || this.actName
      if (actId !== '' && actId !== undefined && actId !== null) actParams.act_id = actId
      if (actName) actParams.act_name = actName
      reportData({
        type: 21,
        data_type,
        page_type: PAGE_TYPE_MAP[name],
        ...actParams,
        ...params,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  .content {
    width: 312px;
    height: 291px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 100px auto 10px auto;
    position: relative;
    .top {
      width: 100%;
      height: 38px;
      text-align: center;
      line-height: 38px;
      color: #fff;
      background: #fe4f4a;
      font-size: 17px;
      font-weight: 700;
    }
    .mid {
      width: 100%;
      height: 100px;
      padding: 0px 20px;
      margin-top: 24px;
    }
    .extra_fn {
      width: 100%;
      font-size: 11px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      color: #3e99d3;
      line-height: 17px;
      padding: 0 32px;
      position: absolute;
      right: 0px;
      bottom: 100px;
    }
    .submit {
      width: 229px;
      height: 39px;
      background: #fe4f4a;
      border-radius: 39px;
      line-height: 39px;
      text-align: center;
      color: #fff;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      font-size: 13px;
      margin: 48px auto 10px auto;
    }
  }
  .close {
    width: 30px;
    display: block;
    margin: 0 auto;
    background-color: #fe4f4a;
    border-radius: 50%;
  }
}
.forgetImg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
  background-repeat: no-repeat;
  background-size: 100%;
  .close {
    width: 20px;
    display: block;
    margin: 550px auto 24px;
  }
}
.jumpGame {
  width: 200px;
  font-size: 11px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-decoration: underline;
  text-align: center;
  color: #999999;
  line-height: 17px;
  margin: 0 auto;
}
</style>
